import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { ScrollContainer } from 'foundations-components/transitional/components/ScrollContainer';
import CompanionFooter from './CompanionFooter';
import QuizMeQuestions from './QuizMeQuestions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const QuizMeTab = () => {
  const [questionIndex, setQuestionIndex] = useState(0);
  const handleQuestionIndex = index => setQuestionIndex(index);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(View, {
      maxBlockSize: "500px",
      padding: "700",
      children: /*#__PURE__*/_jsx(ScrollContainer, {
        maxHeight: "350px",
        children: /*#__PURE__*/_jsx(QuizMeQuestions, {
          handleQuestionIndex: handleQuestionIndex,
          questionIndex: questionIndex
          // TODO: Dummy data for initial implementation
          ,
          quizQuestions: [{
            questionTitle: 'Question 1',
            questionText: 'Question 1 text',
            answers: [{
              answerText: 'Answer 1',
              isCorrect: false,
              answerResponseTitle: 'Answer 1 title',
              answerResponseText: 'Answer 1 text'
            }]
          }],
          quizTitle: "Quiz Title"
        })
      })
    }), /*#__PURE__*/_jsx(CompanionFooter, {
      additionalButtons: /*#__PURE__*/_jsxs(ButtonWrapper, {
        children: [/*#__PURE__*/_jsx(Button, {
          use: "tertiary-light",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.interactiveEducation.quiz.skipQuestion"
          })
        }), /*#__PURE__*/_jsx(Button, {
          use: "tertiary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.interactiveEducation.quiz.nextQuestion"
          })
        })]
      })
    })]
  });
};
export default QuizMeTab;